import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const personalInformation = Loadable(() => import('../../containers/web/personalInformation'));
export default MapTo('vcg/components/soe-home/react/personalInformation')(personalInformation);
